import { render, staticRenderFns } from "./ru.vue?vue&type=template&id=6c42c5e5&scoped=true&lang=html&"
import script from "./ru.vue?vue&type=script&lang=js&"
export * from "./ru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c42c5e5",
  null
  
)

export default component.exports